import Grid from '@mui/material/Grid';
import { useEffect, useState } from 'react';
import { ImageField, ImageInput, NumberInput, SelectInput, TextInput } from 'react-admin';
import { ColorInput } from 'react-admin-color-picker';
import { useFormContext } from 'react-hook-form';
import { QRCode } from 'react-qrcode-logo';
import GridWrapper from 'utils/react-admin/GridWrapper';

interface ModalInputQRCodeProps {
  value: string,
}

const EyeRadiusMap = {
  square: 0,
  round_5: 5,
  round_10: 10,
  eye: [
    [10, 10, 0, 10], // top/left eye
    [10, 10, 10, 0], // top/right eye
    [10, 0, 10, 10], // bottom/left
  ],
}

const CHOICE_QR_STYLE = [
  { id: 'squares', name: 'Squares' },
  { id: 'dots', name: 'Dots' },
]
const CHOICE_LOGO_PADDING_STYLE = [
  { id: 'square', name: 'Square' },
  { id: 'circle', name: 'Circle' },
]
const CHOICE_EYE_RADIUS = [
  { id: 'square', name: 'Square' },
  { id: 'round_5', name: 'Round 5' },
  { id: 'round_10', name: 'Round 10' },
  { id: 'eye', name: 'Eye' },
]

interface ModalInputProps {
  source: string;
}

const ModalInput = ({ source }: ModalInputProps) => {
  // const { watch } = useFormContext();
  const { watch, setValue } = useFormContext();
  const value = watch(source);
  const qrStyle = watch('qrStyle');
  const logoPaddingStyle = watch('logoPaddingStyle');
  const size = watch('size');
  const bgColor = watch('bgColor');
  const fgColor = watch('fgColor');
  const eyeColorOuter = watch('eyeColorOuter');
  const eyeColorInner = watch('eyeColorInner');
  const logoImageInput = watch('logoImageInput');
  const logoOpacity = watch('logoOpacity');
  const eyeRadiusSelect: keyof typeof EyeRadiusMap = watch('eyeRadiusSelect');
  const [eyeRadius, setEyeRadius] = useState<any>(0);
  const [logoImage, setLogoImage] = useState<string | null>(null);

  useEffect(() => {
    setValue('bgColor', '#FFFFFF');
    setValue('fgColor', '#000000');
    setValue('eyeColorOuter', '#000000');
    setValue('eyeColorInner', '#000000');
  }, []);

  useEffect(() => {
    setEyeRadius(EyeRadiusMap[eyeRadiusSelect]);
  }, [eyeRadiusSelect]);

  useEffect(() => {
    if (logoImageInput && logoImageInput.src) {
      setLogoImage(logoImageInput.src);
    } else {
      setLogoImage(null);
    }
  }, [logoImageInput]);

  const logoOnLoad = () => {
  }

  console.log('ModalInputQRCode', size, qrStyle, logoImageInput, logoImage);

  return (
    <>
      <GridWrapper>
        <Grid item container xs={6}>
          <Grid item xs={12}><TextInput source={source} label={'The QR Code Text / URL / etc'} fullWidth helperText={false} /></Grid>
          <Grid item xs={12}><NumberInput source="size" min={150} max={1000} step={10} defaultValue={640} fullWidth /></Grid>
          <Grid item xs={3}><SelectInput source="qrStyle" choices={CHOICE_QR_STYLE} defaultValue={"squares"} fullWidth helperText={false} /></Grid>
          <Grid item xs={3}><SelectInput source="eyeRadiusSelect" choices={CHOICE_EYE_RADIUS} defaultValue={"square"} fullWidth helperText={false} /></Grid>
          <Grid item xs={3}><NumberInput source="logoOpacity" min="0" max="1" step={.1} defaultValue={1} fullWidth helperText={false} /></Grid>
          <Grid item xs={3}><SelectInput source="logoPaddingStyle" choices={CHOICE_LOGO_PADDING_STYLE} defaultValue={"square"} fullWidth helperText={false} /></Grid>
          <Grid item xs={3}><ColorInput source="bgColor" label="Background Color" /></Grid>
          <Grid item xs={3}><ColorInput source="fgColor" label="Dots Color" /></Grid>
          <Grid item xs={3}><ColorInput source="eyeColorOuter" /></Grid>
          <Grid item xs={3}><ColorInput source="eyeColorInner" /></Grid>
          <Grid item xs={6}><ImageInput source="logoImageInput" label="Logo, Must be in Square"><ImageField source="src" title="title" /></ImageInput></Grid>
          <Grid item xs={3}><img onClick={() => setLogoImage(null === logoImage ? '/api/uploads/qr_code_logo/spga_vertical.jpg' : null)} src={'/api/uploads/qr_code_logo/spga_vertical.jpg'} style={{ width: '100%' }} /></Grid>
          <Grid item xs={3}><img onClick={() => setLogoImage(null === logoImage ? '/api/uploads/qr_code_logo/spga_horizontal.jpg' : null)} src={'/api/uploads/qr_code_logo/spga_horizontal.jpg'} style={{ width: '100%' }} /></Grid>
        </Grid>
        <Grid item xs={6}>
          <div style={{ width: '100%', height: '100%', overflow: 'scroll' }}>
            {value
              ? (logoImage
                ? <QRCode size={size} logoOpacity={logoOpacity} value={value} bgColor={bgColor} fgColor={fgColor} logoPaddingStyle={logoPaddingStyle} qrStyle={qrStyle} logoImage={logoImage} logoOnLoad={logoOnLoad} eyeRadius={eyeRadius} eyeColor={{ outer: eyeColorOuter, inner: eyeColorInner }} />
                : <QRCode size={size} logoOpacity={logoOpacity} value={value} bgColor={bgColor} fgColor={fgColor} logoPaddingStyle={logoPaddingStyle} qrStyle={qrStyle} eyeRadius={eyeRadius} eyeColor={{ outer: eyeColorOuter, inner: eyeColorInner }} />)
              : <>
              <h3>Please input your value (text / url / etc) on the top left input box</h3>
              <p>and a QR Code will be shown.</p>
            </>
            }
          </div>
        </Grid>
      </GridWrapper>
    </>
  )
}

ModalInput.defaultProps = {
}

export default ModalInput;
